import { createSvgIcon } from '@mui/material/utils';

const SearchIcon = createSvgIcon(
    <svg viewBox="0 0 24 24" fill="none">
        <g strokeWidth="2">
            <circle cx="10.5" cy="10.5" r="9.5" />
            <line x1="22" y1="22" x2="17" y2="17" />
        </g>
    </svg>,
    'Search'
);

export default SearchIcon;
